import { ApplicationRoutes } from '../../../app-routes-names'

export const EmployeeRoutes = {
  list: 'list',
  employeeDetails: 'details/:employeeId',
  laborSummary: 'labor-summary',
  technicianSummary: 'back-shop-summary',
  technicianList: 'back-shop-list',
  serviceAdvisorSummary: 'front-shop-summary',
  serviceAdvisorList: 'front-shop-list',
  employeeEfficiencyMovingAverage: 'employee-efficiency-moving-average',
  invoicePackageLines: 'invoice-package-lines'
}

const { employee } = ApplicationRoutes

export const EmployeePaths = {
  list: `/${employee}/${EmployeeRoutes.list}`,
  employeeDetails: (employeeId: string) =>
    `/${employee}/${EmployeeRoutes.employeeDetails.replace(':employeeId', employeeId)}`,
  laborSummary: `/${employee}/${EmployeeRoutes.laborSummary}`,
  technicianSummary: `/${employee}/${EmployeeRoutes.technicianSummary}`,
  technicianList: `/${employee}/${EmployeeRoutes.technicianList}`,
  serviceAdvisorSummary: `/${employee}/${EmployeeRoutes.serviceAdvisorSummary}`,
  serviceAdvisorList: `/${employee}/${EmployeeRoutes.serviceAdvisorList}`,
  employeeEfficiencyMovingAverage: `/${employee}/${EmployeeRoutes.employeeEfficiencyMovingAverage}`,
  invoicePackageLines: `/${employee}/${EmployeeRoutes.invoicePackageLines}`
}
